<template>
  <section>
    <Statistics @show="show"></Statistics>
    <Categories v-if="activeBlock == 0"></Categories>
    <Products v-if="activeBlock == 1"></Products>
    <Fields v-if="activeBlock == 2"></Fields>
    <FieldValue v-if="activeBlock == 3"></FieldValue>
  </section>
</template>

<script>
import Statistics from "./Statistics";
import Categories from "./Categories";
import Products from './Products.vue';
import Fields from './Fields.vue';
import FieldValue from './Component/FieldValue.vue'
export default {
	components: { Statistics, Categories, Products, Fields, FieldValue },
	data() {
    return {
			activeBlock: 0
    };
  },
  methods: {
		show(index) {
			this.activeBlock = index
		}
  },
  mounted() {
		//
  }
};
</script>
